var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"value":_vm.value,"hint":`Код АТХ ${this.maxlength !== 5 ? 'от 5 до ' : ''}${
    this.maxlength || 7
  } символов`,"rules":[_vm.rules_latin, _vm.rules_min, _vm.rules_max],"maxlength":_vm.maxlength,"counter":""},on:{"input":_vm.doChange,"blur":_vm.doBlur}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }